import axios from 'axios';
import { getFromLocalStorage } from '../../global/helpers';

export class LoyaltyService {
  static API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/api/v1/`;

  static getCurrentReceipt = async () => {
    const response = await axios({
      method: 'get',
      url: `${LoyaltyService.API_BASE_URL}orders/soft/products`,
    });
    return response.data;
  };

  static getCurrentPharmacist = async () => {
    const response = await axios({
      method: 'get',
      url: `${LoyaltyService.API_BASE_URL}loyalty/ph/balance`,
      headers: {
        Authorization: `Bearer ${getFromLocalStorage('accessToken')}`,
      },
    });
    return response.data;
  };

  static getClientInfo = async (phone: string) => {
    const response = await axios({
      method: 'get',
      url: `${LoyaltyService.API_BASE_URL}loyalty/balance?phone=${phone}&type=pharmacy`,
      headers: {
        Authorization: `Bearer ${getFromLocalStorage('accessToken')}`,
      },
    });
    return response.data;
  };

  static applyBonuses = async (phone: string) => {
    const response = await axios({
      method: 'post',
      url: `${LoyaltyService.API_BASE_URL}auth/loyalty`,
      data: {
        phone,
      },
    });
    return response.data;
  };

  static submitLoyaltyOrder = async (payload: any) => {
    const response = await axios({
      method: 'post',
      url: `${LoyaltyService.API_BASE_URL}orders/confirm`,
      data: payload,
    });
    return { ...response.data, docId: payload.doc_id };
  };

  static generateLoyaltyReport = async (
    data: {
      from: string;
      to: string;
      integration_code: string;
      type: string;
      source_code?: string;
      phone?: string;
    },
    pdfF: boolean,
    xls: boolean
  ) => {
    const fileName = data.source_code
      ? `${data.source_code}/${Math.round(Date.now() / 1000)}`
      : `${Math.round(Date.now() / 1000)}`;
    try {
      await fetch(
        `${LoyaltyService.API_BASE_URL}reports/loyalty/${pdfF ? 'pdf' : 'xls'}`,
        {
          method: 'POST',
          body: JSON.stringify(data),
          headers: {
            Authorization: `Bearer ${getFromLocalStorage('accessToken')}`,
          },
        }
      )
        .then((resp) => {
          if (resp.status !== 200) {
            window.alert('Error');
            return Promise.reject();
          }
          return resp.blob();
        })
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.style.display = 'none';
          a.href = url;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((err) => console.error(err));
      return {};
    } catch (err) {
      throw err;
    }
  };
}
